export class Payment {
    iban: string;
    document_type: number;
    document: string;
    country: string;
    name: string;
    last_name: string;
    second_last_name: string;
    company: string;
}
